import { render, staticRenderFns } from "./guest-list.vue?vue&type=template&id=3d8f8dc6"
import script from "./guest-list.vue?vue&type=script&lang=js"
export * from "./guest-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports